import { Translator } from 'Translator';
import classnames from 'classnames';
import Pattern from 'components/LearningCenterPattern/Top';
import LocalizedLink from 'components/LocalizedLink';
import ChevronIcon from 'components/icons/ChevronIcon';
import useViewport from 'hooks/useViewport';
import React from 'react';
import { isCordova } from 'utils/platform';

const CSS = require('./BackBar.module.scss');

interface BackBarProps {
  to: string;
}

function BackBar({ to }: BackBarProps) {
  const { width } = useViewport();

  return (
    <>
      {isCordova() && (
        <div className={CSS.Header}>
          <LocalizedLink
            className={CSS.BackButton}
            to={to}
            replace
            aria-label={Translator.translate(
              'UserEnvironment.Common.back',
              {},
              true,
            )}
          >
            <ChevronIcon
              width={8}
              height={14}
              color="#4A4A4A"
              direction="left"
            />
          </LocalizedLink>
        </div>
      )}
      <div
        className={classnames(CSS.PatternContainer, {
          [CSS.PatternContainerApp]: isCordova(),
        })}
      >
        <Pattern width={width} />
      </div>
    </>
  );
}

export default BackBar;
